export var AccommodationStatusEnum;
(function (AccommodationStatusEnum) {
    AccommodationStatusEnum[AccommodationStatusEnum["OptedFor"] = 1] = "OptedFor";
    AccommodationStatusEnum[AccommodationStatusEnum["OptedOut"] = 2] = "OptedOut";
    AccommodationStatusEnum[AccommodationStatusEnum["Unavailable"] = 3] = "Unavailable";
})(AccommodationStatusEnum || (AccommodationStatusEnum = {}));
